module.exports = __webpack_public_path__ + "static/eula-1849d843a3f4dcf5b59525e08822caa0.png";